// GeoJSON boundary of the Bromo Tower Arts & Entertainment District, drawn on
// the Visit map via map.data (see google-map.js). Source: Maryland iMAP
// "Arts and Entertainment Districts" (MD_IncentiveZones FeatureServer, OBJECTID 20),
// reprojected to WGS84. Static export — update if the official boundary changes.
export const bromoDistrictBoundary = {
  "type": "Feature",
  "properties": {
    "name": "Bromo Tower Arts and Entertainment District"
  },
  "geometry": {
    "type": "Polygon",
    "coordinates": [
      [
        [
          -76.617895,
          39.28939
        ],
        [
          -76.618278,
          39.295626
        ],
        [
          -76.619219,
          39.295599
        ],
        [
          -76.61925,
          39.296017
        ],
        [
          -76.619258,
          39.296193
        ],
        [
          -76.61832,
          39.296226
        ],
        [
          -76.618389,
          39.297405
        ],
        [
          -76.619168,
          39.297378
        ],
        [
          -76.619363,
          39.300691
        ],
        [
          -76.620164,
          39.301172
        ],
        [
          -76.620003,
          39.298414
        ],
        [
          -76.621478,
          39.298362
        ],
        [
          -76.621509,
          39.298884
        ],
        [
          -76.621572,
          39.298882
        ],
        [
          -76.621634,
          39.298886
        ],
        [
          -76.621696,
          39.298896
        ],
        [
          -76.621756,
          39.298911
        ],
        [
          -76.621812,
          39.298932
        ],
        [
          -76.621866,
          39.298958
        ],
        [
          -76.621914,
          39.298989
        ],
        [
          -76.622763,
          39.299689
        ],
        [
          -76.623417,
          39.299071
        ],
        [
          -76.622275,
          39.297876
        ],
        [
          -76.622679,
          39.297266
        ],
        [
          -76.622607,
          39.294814
        ],
        [
          -76.622631,
          39.294813
        ],
        [
          -76.622509,
          39.292756
        ],
        [
          -76.622488,
          39.292757
        ],
        [
          -76.622442,
          39.291977
        ],
        [
          -76.622768,
          39.291966
        ],
        [
          -76.622755,
          39.291745
        ],
        [
          -76.622433,
          39.291756
        ],
        [
          -76.622433,
          39.291754
        ],
        [
          -76.622414,
          39.291422
        ],
        [
          -76.624265,
          39.291356
        ],
        [
          -76.624223,
          39.290259
        ],
        [
          -76.623733,
          39.290277
        ],
        [
          -76.623631,
          39.288557
        ],
        [
          -76.623631,
          39.288556
        ],
        [
          -76.620877,
          39.288655
        ],
        [
          -76.62081,
          39.28751
        ],
        [
          -76.619314,
          39.287564
        ],
        [
          -76.619419,
          39.289336
        ],
        [
          -76.617895,
          39.28939
        ]
      ]
    ]
  }
};
